import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae2bf3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-tree__node"
}
const _hoisted_2 = { class: "uf-tree__item-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_tree_node = _resolveComponent("uf-tree-node")!

  return (_ctx.node)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["uf-tree__item", {
        'uf-tree__item--checked': _ctx.isChecked
      }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onclick && _ctx.onclick(...args)))
        }, [
          (_ctx.multiple)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.isChecked)
                  ? (_openBlock(), _createBlock(_component_van_icon, {
                      key: 0,
                      name: "circle",
                      size: "16",
                      color: "#ccc",
                      style: {"margin-right":"10px"}
                    }))
                  : (_openBlock(), _createBlock(_component_van_icon, {
                      key: 1,
                      name: "checked",
                      size: "16",
                      color: "#3d6eeb;",
                      style: {"margin-right":"10px"}
                    }))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.node.place), 1),
          (_ctx.node.lists && _ctx.node.lists.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "uf-tree__item-more",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moreClick && _ctx.moreClick(...args)), ["stop"]))
              }, [
                _createVNode(_component_van_icon, {
                  name: _ctx.hasMore ? 'arrow-down' : 'arrow',
                  size: "18",
                  color: "#999"
                }, null, 8, ["name"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.lists, (child) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: child.id
          }, [
            (_ctx.hasMore)
              ? (_openBlock(), _createBlock(_component_uf_tree_node, {
                  key: 0,
                  node: child
                }, null, 8, ["node"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}